import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "@mui/icons-material";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #0a2f2f 0%, #0d3b3b 50%, #0a2f2f 100%)",
        overflowX: "hidden",
        px: { xs: 2, sm: 4 },
        py: { xs: 6, sm: 8 },
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      {/* Floating background orbs */}
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={i}
          style={{
            position: "absolute",
            width: 60 + i * 40,
            height: 60 + i * 40,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(255,215,0,0.08) 0%, transparent 70%)",
            left: `${10 + i * 20}%`,
            top: `${15 + (i % 2) * 50}%`,
            pointerEvents: "none",
          }}
          animate={{ y: [0, -40, 0], x: [0, 20, 0], scale: [1, 1.15, 1] }}
          transition={{
            duration: 6 + i * 2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.8,
          }}
        />
      ))}

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          type: "spring",
          stiffness: 120,
          damping: 14,
          delay: 0.15,
        }}
        style={{ width: "100%", maxWidth: 1000, zIndex: 1 }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 4,
            boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
            p: { xs: 3, sm: 4, md: 5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src="/page-not-found.png"
            alt="Page not found"
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: 2,
              mb: 3,
            }}
          />

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <Typography
              variant="body1"
              sx={{
                mb: 3,
                maxWidth: 450,
                mx: "auto",
                textAlign: "center",
              }}
            >
              Let's get you back on track.
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2.5,
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button
                component={Link}
                to="/"
                variant="contained"
                startIcon={<Home />}
                sx={{
                  backgroundColor: "#FFD700",
                  color: "#00786F",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: "none",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                  transition:
                    "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                }}
              >
                Go Home
              </Button>

              <Button
                onClick={() => navigate(-1)}
                variant="outlined"
                startIcon={<ArrowLeft />}
                sx={{
                  color: "#111827",
                  borderColor: "rgba(0,0,0,0.2)",
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: "none",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                  transition:
                    "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                }}
              >
                Go Back
              </Button>
            </Box>
          </motion.div>
        </Box>
      </motion.div>
    </Box>
  );
};

export default NotFound;
